document.addEventListener('DOMContentLoaded', function() {
  const searchForm = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');


  function formatPrice(price) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price / 100);
  }

  searchForm.addEventListener('input', function() {
    const query = searchForm.value;

    if (query.length > 2) {
      fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide`)
        .then(response => response.json())
        .then(data => {
          const products = data.resources.results.products;
          let resultsHTML = '';

          if (products.length > 0) {
            products.forEach(product => {
              console.log(product);

                let formattedPrice = Shopify.formatMoney(product.price);
                formattedPrice = formattedPrice.replace(/(\.\d{2})$/, '');

                let formattedCompareAtPrice = null;
                if (product.compare_at_price && product.compare_at_price > product.price) {
                  formattedCompareAtPrice = Shopify.formatMoney(product.compare_at_price);
                  formattedCompareAtPrice = formattedCompareAtPrice.replace(/(\.\d{2})$/, '');
                }

                resultsHTML += `
                  <div class="product">
                    <div class="details">
                      <a href="${product.url}">
                        ${product.title.split(" - ")[0]}
                      </a>

                      <a href="${product.url}" class="price">
                        ${formattedPrice}
                      </a>
                    </div><!-- Details -->

                    <div class="single-image">
                      <a href="${product.url}">
                      <span class="label">${
                        product.title.split(" - ")[1]
                      }</span>
                      <img src="${product.featured_image.url}" alt="${
                  product.title
                }" />
                      </a>
                    </div>

                  </div><!-- Product -->
                `;

            });

            // Show the "Showing Top Results" message and "View All Search Results" link
            //showMoreLink.href = `/search?q=${encodeURIComponent(query)}`;
          } else {
            resultsHTML = '<span class="product ag">No Results Found</span>';
          }

          searchResults.innerHTML = resultsHTML;
        })
        .catch(error => {
          console.error('Error fetching search results:', error);
        });
    } else {
      searchResults.innerHTML = '';
    }
  });
});